export default function Button({ children, className = '', variant = 'primary', ...props }) {
    const base = 'px-2 py-2 rounded font-semibold';
    const variants = {
        primary: 'bg-blue-600 text-white hover:bg-blue-700',
        secondary: 'bg-white text-blue-600 hover:bg-gray-100',
        ghost: 'bg-transparent text-white border border-white hover:bg-white hover:text-black',
        outline: 'bg-transparent border border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white',
    };

    return (
        <button className={`${base} ${variants[variant]} ${className}`} {...props}>
            {children}
        </button>
    );
}
